// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"381f08e8","453":"ee7b6f0a","455":"00a514e1"}[chunkId] + ".chunk.js";
};